// src/Pages/Contact.jsx
import * as React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { ThemeProvider, createTheme, Typography, useMediaQuery } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Footer from "./Footer";

export default function Contact() {
  const base = createTheme();

  const theme = createTheme({
    typography: {
      fontFamily: "Helvetica",
      h1: { fontSize: "3rem", fontWeight: 200 },
      body1: {
        fontSize: "1.25rem",
        fontWeight: 200,
        lineHeight: 1.5,
        [base.breakpoints.down("sm")]: {
          fontSize: "1.25rem",
          fontWeight: 300,
        },
      },
    },
  });

  const isDesktop = useMediaQuery("(min-width:600px)");
  const [clicked, setClicked] = React.useState(false);
  const [email, setEmail] = React.useState("moc.itnesepdinoel@tmgm");

  const handleClick = () => {
    setClicked(!clicked);
    setEmail(email.split("").reverse().join(""));
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="start"
        marginTop="5vh"
        marginBottom="5vh"
        minHeight="100vh"
        maxWidth="100vw"
        overflowX="hidden"
        pb="10vh"
      >
        <Grid container direction="column" alignItems="center" justifyContent="center">
          
          {/* Title */}
          <Grid item sx={{ mb: "5vh" }}>
            <Typography
              variant="h1"
              component={RouterLink}
              to="/"
              sx={{
                textAlign: "center",
                color: "inherit",
                textDecoration: "none",
                cursor: "pointer",
              }}
            >
              // contact
            </Typography>
          </Grid>

          {/* Subtitle */}
          <Grid item sx={{ width: isDesktop ? "35vw" : "80vw", mb: "5vh" }}>
            <Typography variant="body1" sx={{ textAlign: "center" }}>
              <b>for bookings, prints, and existential (or trivial) matters</b>
            </Typography>
          </Grid>

          {/* // available for */}
          <Grid item sx={{ width: isDesktop ? "35vw" : "80vw", textAlign: "left", mb: "3vh" }}>
            <Typography
              sx={{
                fontFamily: "Helvetica",
                fontSize: { xs: "1.6rem", sm: "2.2rem" },
                fontWeight: { xs: 300, sm: 200 },
              }}
            >
              <b>// available for</b>
            </Typography>
          </Grid>

          {/* Services list */}
          <Grid item sx={{ width: isDesktop ? "35vw" : "80vw" }}>
            {[
              " ",
              "DJing",
              "music production and sound design",
              " ",
              " ",
              "photography and post-production",
              "creative and art direction",
              "editorial and event documentation",
              " ",
              " ",
              "conceptual consulting",
              "writing and curation",
            ].map((item, index) => (
              <Typography
                key={index}
                variant="body1"
                sx={{
                  textAlign: "center",
                  marginBottom: "2vh",
                }}
              >
                {item}
              </Typography>
            ))}
          </Grid>

          {/* Button row (email, instagram, linktr.ee) */}
          <Grid
            item
            sx={{
              width: isDesktop ? "35vw" : "80vw",
              marginTop: "3vh",
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              justifyContent: "center",
              gap: "2vw",
            }}
          >
            {/* Email */}
            <Button
              onClick={handleClick}
              style={{
                color: "black",
                textDecoration: "none",
                fontSize: "1.2rem",
                fontFamily: "Helvetica",
              }}
            >
              e-mail
            </Button>

            {/* Instagram */}
            <Button
              onClick={() =>
                window.open("https://www.instagram.com/hennibbale/", "_blank")
              }
              style={{
                color: "black",
                textDecoration: "none",
                fontSize: "1.2rem",
                fontFamily: "Helvetica",
              }}
            >
              instagram
            </Button>

            {/* Linktree */}
            <Button
              onClick={() =>
                window.open("https://linktr.ee/hennibbale", "_blank")
              }
              style={{
                color: "black",
                textDecoration: "none",
                fontSize: "1.2rem",
                fontFamily: "Helvetica",
              }}
            >
              linktr.ee
            </Button>
          </Grid>

          {/* Revealed email */}
          {clicked && (
            <Grid item sx={{ width: isDesktop ? "35vw" : "80vw", mt: "2vh" }}>
              <Typography
                component="a"
                href={"mailto:" + email}
                sx={{
                  color: "black",
                  textDecoration: "none",
                  fontSize: "1rem",
                  wordBreak: "break-word",
                }}
              >
                {email}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>

      <Footer fixed />
    </ThemeProvider>
  );
}
